import * as Sentry from "@sentry/nextjs";
import {NextPage} from "next";
import {useTranslation} from "ni18n";
import React from "react";
import {LeverJobPostingResponse} from "src/_services/types";
import {LEVER_URI} from "src/components/_common/_constants";
import Bios from "src/components/v5/About/Bios";
import Careers from "src/components/v5/About/Careers";
import CoreValues from "src/components/v5/About/CoreValues";

import AboutUs from "../components/v5/About/AboutUs";
import Hero from "../components/v5/About/Hero";
import Layout from "../components/v5/Layout";
import {NavTheme} from "../components/v5/Nav/useNavState";

type Props = {
  jobs: LeverJobPostingResponse[];
};

const About: NextPage<Props> = ({jobs = []}) => {
  const i18n = useTranslation();

  return (
    <Layout
      pageTitle={i18n.t("About Us | Carbon Health")}
      pageImage="about-us-mint"
      navTheme={NavTheme.LIGHT}
      wrapClasses="ovf-unset" // required for position sticky to work
    >
      <Hero jobCount={jobs.length} />
      <AboutUs />
      <CoreValues />
      <Bios />
      <Careers jobs={jobs} />
    </Layout>
  );
};

About.getInitialProps = async () => {
  const jobs = await fetch(LEVER_URI)
    .then(res => res.json())
    .catch(err => {
      Sentry.captureException(err);
      return [];
    });
  return {jobs};
};

export default About;
